var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendingIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 13.5799C2.16602 7.59683 7.01626 2.74658 12.9993 2.74658C18.9824 2.74658 23.8327 7.59683 23.8327 13.5799C23.8327 14.7122 23.6589 15.804 23.3367 16.8299H14.7522L17.2183 11.8977C17.4859 11.3626 17.269 10.7119 16.7338 10.4443C16.1986 10.1767 15.548 10.3936 15.2804 10.9288L12.3298 16.8299H2.66197C2.33973 15.804 2.16602 14.7122 2.16602 13.5799Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61523 18.9966C5.48837 22.2347 8.9894 24.4132 12.9993 24.4132C17.0091 24.4132 20.5101 22.2347 22.3833 18.9966H3.61523Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendingIconSelected);
export default __webpack_public_path__ + "static/media/vending-icon-selected.aa61b30bc32b5cb1fc91437a05bd2b71.svg";
export { ForwardRef as ReactComponent };